import { Polling } from 'components/common';
import { useEffect } from 'react';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { getMixpassWhitelistStatus } from 'utils/mixpassService';

const useMixpassWhitelistStatus = (whitelist: string) => {
  const [shouldRefetch, setShouldRefetch] = useState<boolean>(true);

  const { data, isLoading, isError } = useQuery(
    ['mixpass-whitelist-status', whitelist],
    async () => getMixpassWhitelistStatus(whitelist),
    {
      enabled: Boolean(whitelist),
      refetchInterval: shouldRefetch ? Polling.slow : false,
    }
  );

  const { merkleRoot, isEnabled } = data || {};

  // stop refetching after whitelist is enabled
  useEffect(() => {
    if (shouldRefetch && isEnabled) {
      setShouldRefetch(false);
    }
  }, [shouldRefetch, isEnabled]);

  return {
    isLoading,
    isError,
    merkleRoot,
    isEnabled,
  };
};

export default useMixpassWhitelistStatus;
